// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ahAo","comment":"styles_comment__-dRKy"};